import Colcade from 'colcade';

if (document.querySelector('.grid')) {
  new Colcade( '.grid', {
    columns: '.grid-col',
    items: '.grid-item'
  });
}
